/**
 * BottomNavRistorazione — Bottom nav 3 voci (Home / Documenti / Impostazioni)
 * usata solo nel deploy `REACT_APP_VARIANT=ristorazione`.
 */
import { NavLink } from "react-router-dom";
import { Home, BookOpen, Settings } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const VOICES = [
  { to: "/oggi",          label: "Home",         icon: Home,     testId: "rist-nav-home" },
  { to: "/documenti",     label: "Documenti",    icon: BookOpen, testId: "rist-nav-doc" },
  { to: "/impostazioni",  label: "Impostazioni", icon: Settings, testId: "rist-nav-settings" },
];

export default function BottomNavRistorazione() {
  const { user } = useAuth();
  // R52.16: SA e Consulenti NON sono utenti operativi della Ristorazione —
  // usano solo il SaDrawer per le pagine di direzione. Nascondiamo la bottom-nav.
  if (user && (user.role === "superadmin" || user.role === "consultant")) return null;

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 px-2 py-2 flex justify-around shadow-2xl z-40"
      data-testid="bottomnav-ristorazione"
    >
      <div className="max-w-md lg:max-w-3xl w-full mx-auto flex justify-around">
        {VOICES.map((v) => {
          const Icon = v.icon;
          return (
            <NavLink
              key={v.to}
              to={v.to}
              data-testid={v.testId}
              className={({ isActive }) =>
                `flex flex-col items-center gap-0.5 px-4 py-1 ${isActive ? "text-[#13294B]" : "text-slate-500"}`
              }
            >
              {({ isActive }) => (
                <>
                  <Icon className="w-6 h-6" strokeWidth={isActive ? 2.4 : 1.8} fill={isActive ? "currentColor" : "none"} fillOpacity={isActive ? 0.15 : 0} />
                  <span className={`text-[10px] ${isActive ? "font-bold" : "font-medium"}`}>{v.label}</span>
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
